import { RouteRecordRaw } from 'vue-router';

import { appBar } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain.ts';

export const LoginSharesRoute: RouteRecordRaw = {
	name: RouteKeys.LOGIN_SHARES,
	path: '/public/sharings',
	alias: '',
	components: {
		default: () => import('~/_v3/public-shares/ui/pages/LoginSharePage.vue')
	}
};

export const PublicSharesRoute: RouteRecordRaw = {
	name: RouteKeys.PUBLIC_SHARES,
	path: '/public/sharings-list',
	alias: '',
	components: {
		default: () => import('~/_v3/public-shares/ui/pages/PublicSharesPage.vue'),
		...appBar
	},
	props: {
		appbar: { isMenu: false, isLogged: false }
	},
	meta: {
		guest: true
	}
};

export const ExpiredSharesRoute: RouteRecordRaw = {
	name: RouteKeys.PUBLIC_SHARES_EXPIRED,
	path: '/public/sharings-expired',
	alias: '',
	components: {
		default: () => import('~/_v3/public-shares/ui/pages/ExpiredLinkPublicSharesPage.vue')
	}
};
